import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatCityLabel } from "../utils/resolveRegion";

export default function InboxPage() {
  const navigate = useNavigate();
  const currentUserId = Number(localStorage.getItem("user_id"));
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadInbox = async () => {
    try {
      const res = await fetch(
        `/api/inbox?current_user_id=${currentUserId}`
      );
      const data = await res.json();

      if (Array.isArray(data)) {
        setRequests(data);
      } else {
        setRequests([]);
      }
    } catch (err) {
      console.error("加载收件箱失败:", err);
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!currentUserId) {
      navigate("/login");
      return;
    }

    loadInbox();
  }, [currentUserId, navigate]);

 const handleRespond = async (requestId, action) => {
  try {
    const res = await fetch("/api/friend-request/respond", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        request_id: requestId,
        action,
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      alert(data.detail || "操作失败");
      return;
    }

    alert(action === "accepted" ? "已通过好友申请" : "已拒绝好友申请");

    window.dispatchEvent(new Event("friendRequestUpdated"));

    if (action === "accepted") {
      navigate("/center/friends");
      return;
    }

    loadInbox();
  } catch (err) {
    console.error("处理好友申请失败:", err);
    alert("操作失败");
  }
};


  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">收件箱</h2>
        <button
          onClick={() => navigate("/center")}
          className="text-sm text-pink-500"
        >
          返回个人中心
        </button>
      </div>

      {loading ? (
        <p className="text-center text-gray-400 py-10">加载中...</p>
      ) : requests.length === 0 ? (
        <p className="text-center text-gray-400 py-10">暂无新的好友申请</p>
      ) : (
        <div className="space-y-4">
          {requests.map((item) => (
            <div
              key={item.request_id}
              className="border rounded-xl p-4 flex items-center gap-4"
            >
              <img
                src={
                  item.avatar
                    ? `${item.avatar}`
                    : "https://via.placeholder.com/56"
                }
                alt={item.name}
                className="w-14 h-14 rounded-full object-cover"
              />

              <div className="flex-1">
                <p className="font-semibold">{item.name}</p>
                <p className="text-sm text-gray-500">
                  {formatCityLabel(item.province, item.city, item.district, "未填写城市")}
                </p>
                <p className="text-xs text-gray-400 mt-1">
                  想添加你为好友
                </p>
              </div>

              <div className="flex gap-2">
                <button
                  onClick={() => handleRespond(item.request_id, "accepted")}
                  className="px-4 py-2 bg-pink-500 text-white rounded-lg text-sm"
                >
                  同意
                </button>
                <button
                  onClick={() => handleRespond(item.request_id, "rejected")}
                  className="px-4 py-2 border rounded-lg text-sm"
                >
                  拒绝
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
